import { IconButton } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { HiPlus } from "react-icons/hi";
import CreateEditGangTarget from "./components/CreateEditGangTarget";
import ConfirmDeleteModal from "./components/ConfirmDeleteModal";
import { usePermission } from "Context/PermissionContext";

const GangTargets = () => {
  const [gangTargets, setGangTargets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalStates, setModalStates] = useState({
    create: false,
    edit: false,
    delete: false,
  });
  const [selectedTarget, setSelectedTarget] = useState({});
  const { permissions } = usePermission();
  const currentTabPermissions =
    permissions?.gangRankings?.subModule?.gangTarget?.permissions;

  const fetchGangTargets = () => {
    setLoading(true);

    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/gang-targets/get-all`,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Response of fetchGangTargets----->", response.data);
        setGangTargets(response.data.gangTargets || []);
      })
      .catch((error) => {
        console.log("Error in fetchGangTargets: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchGangTargets();
  }, []);

  const handleActionButtonClick = (action, data) => {
    if (action === "create") {
      setModalStates((prev) => ({
        ...prev,
        create: true,
      }));
    } else if (action === "edit") {
      setSelectedTarget(data);
      setModalStates((prev) => ({
        ...prev,
        edit: true,
      }));
    } else if (action === "delete") {
      setSelectedTarget(data);
      setModalStates((prev) => ({
        ...prev,
        delete: true,
      }));
    }
  };

  return (
    <div className="mx-auto mt-5 w-auto rounded-t-2xl">
      <div className="rounded-2xl bg-white py-5 shadow-sm">
        <div className=" flex flex-col items-center justify-between space-y-4 p-5 text-navy-600 shadow-sm md:flex-row md:space-y-0">
          <h2 className="text-2xl font-semibold tracking-wide">Gang Targets</h2>
          {currentTabPermissions?.create && (
            <div className="flex w-full justify-between md:w-auto">
              <button
                onClick={() => handleActionButtonClick("create")}
                className="flex w-full items-center justify-center rounded-full bg-[#c51369] p-3 text-white hover:bg-[#a10f5b] hover:shadow-lg focus:outline-none md:w-auto"
              >
                <HiPlus className="h-5 w-5" />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="mb-5 overflow-x-auto">
        <table className="w-full border text-left text-sm">
          <thead className="bg-[#e0ced7] text-gray-700">
            <tr>
              <th className="border  py-2 text-center">Sl No.</th>
              <th className="border  py-2 text-center">Target Type</th>
              <th className="border  py-2 text-center">Active Hours</th>
              <th className="border  py-2 text-center">Games</th>
              <th className="border  py-2 text-center">Gift Coins</th>
              <th className="border  py-2 text-center">Status</th>
              {/* <th className="border px-4 py-2">Active From</th>
                <th className="border px-4 py-2">Active Till</th> */}
              {/* {(currentTabPermissions?.edit ||
                currentTabPermissions?.delete) && (
                <th className="border px-4 py-2 text-center">Actions</th>
              )} */}
            </tr>
          </thead>

          <tbody>
            {gangTargets?.map((gt, index) => (
              <tr key={gt._id} className="border-b bg-white">
                <td className="border px-4 py-2 text-center">{index + 1}</td>
                {/* Target Type */}
                <td className="border px-4 py-2 text-center">
                  {gt.targetType}
                </td>
                {/* Active Hours */}
                <td className="border px-4 py-2">
                  <div className="flex flex-col items-center">
                    <div>
                      <span className="text-center font-medium">
                        Hours/Day:
                      </span>{" "}
                      {gt.activeHours?.hoursPerDay}
                    </div>
                    <div>
                      <span className="text-center font-medium">Rank Pts:</span>{" "}
                      {gt.activeHours?.rankPoints}
                    </div>
                  </div>
                </td>
                {/* Games */}
                <td className="border px-4 py-2">
                  <div className="flex flex-col items-center">
                    <div>
                      <span className="text-center font-medium">
                        Games/Day:
                      </span>{" "}
                      {gt.games?.gamesPerDay}
                    </div>
                    <div>
                      <span className="text-center font-medium">Rank Pts:</span>{" "}
                      {gt.games?.rankPoints}
                    </div>
                  </div>
                </td>
                {/* Gift Coins */}
                <td className="border px-4 py-2">
                  <div className="flex flex-col items-center">
                    <div>
                      <span className="font-medium">Coins/Day:</span>{" "}
                      {gt.giftCoins?.giftCoinsPerDay}
                    </div>
                    <div>
                      <span className=" font-medium">Rank Pts:</span>{" "}
                      {gt.giftCoins?.rankPoints}
                    </div>
                  </div>
                </td>
                {/* Status */}
                <td className="border px-4 py-2 text-center">
                  {gt.isActive ? (
                    <button title="Actions can't be performed on Active gang targets">
                      ✅ Active
                    </button>
                  ) : (
                    <div className="flex justify-center">
                      {currentTabPermissions?.edit && (
                        <IconButton
                          color="primary"
                          onClick={() => handleActionButtonClick("edit", gt)}
                        >
                          <FaEdit size={16} />
                        </IconButton>
                      )}
                      {currentTabPermissions?.delete && (
                        <IconButton
                          color="error"
                          onClick={() => handleActionButtonClick("delete", gt)}
                        >
                          <FaTrash size={12} />
                        </IconButton>
                      )}
                    </div>
                  )}
                </td>
                {/* Active From */}

                {/* <td className="border px-4 py-2">
                    {gt.activeFrom
                      ? new Date(gt.activeFrom).toLocaleDateString()
                      : "—"}
                  </td> */}
                {/* Active Till */}
                {/* <td className="border px-4 py-2">
                    {gt.activeTill
                      ? new Date(gt.activeTill).toLocaleDateString()
                      : "—"}
                  </td> */}
                {/* Action Buttons */}
                {/* {(currentTabPermissions?.edit ||
                  currentTabPermissions?.delete) && (
                  <td className="space-x-2 border px-4 py-2">
                    {gt.isActive ? (
                      <p className=" text-center text-xs italic tracking-wide text-red-500">
                        Actions can't be performed on active one.
                      </p>
                    ) : (
                      <div className="flex justify-center">
                        {currentTabPermissions?.edit && (
                          <IconButton
                            color="primary"
                            onClick={() => handleActionButtonClick("edit", gt)}
                          >
                            <FaEdit size={16} />
                          </IconButton>
                        )}
                        {currentTabPermissions?.delete && (
                          <IconButton
                            color="error"
                            onClick={() =>
                              handleActionButtonClick("delete", gt)
                            }
                          >
                            <FaTrash size={12} />
                          </IconButton>
                        )}
                      </div>
                    )}
                  </td>
                )} */}
              </tr>
            ))}

            {/* No Data */}
            {gangTargets?.length === 0 && (
              <tr>
                <td colSpan="8" className="py-4 text-center text-gray-500">
                  No gang targets found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Modals */}
        {modalStates.create && (
          <CreateEditGangTarget
            open={modalStates.create}
            handleClose={() =>
              setModalStates((prev) => ({
                ...prev,
                create: false,
              }))
            }
            fetchGangTargets={fetchGangTargets}
          />
        )}
        {modalStates.edit && (
          <CreateEditGangTarget
            open={modalStates.edit}
            handleClose={() =>
              setModalStates((prev) => ({
                ...prev,
                edit: false,
              }))
            }
            fetchGangTargets={fetchGangTargets}
            editData={selectedTarget}
          />
        )}
        {modalStates.delete && (
          <ConfirmDeleteModal
            visible={modalStates.delete}
            onClose={() =>
              setModalStates((prev) => ({
                ...prev,
                delete: false,
              }))
            }
            fetchGangTargets={fetchGangTargets}
            target={selectedTarget}
          />
        )}
      </div>
    </div>
  );
};

export default GangTargets;
